(() => {
  const formatMoney = (cents, format) => {
    const value = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/g, value);
  };

  const updatePrices = (variant) => {
    if (!variant || !variant.price) {
      return
    };

    const tiersDataEl = document.getElementById('CartDiscountTiersData');
    if (!tiersDataEl) {
      return
    };

    let tiers = [], currencyCodeEnable = false;

    try {
      const parsedData = JSON.parse(tiersDataEl.textContent);
      tiers = parsedData.tiers;
      currencyCodeEnable = parsedData.currencyCodeEnable;
    } catch (err) {
      return;
    }

    const cartTotal = window.cart?.originalTotal || 0;
    let activeDiscount = 0;

    tiers.forEach(tier => {
      if (cartTotal >= tier.limit && tier.discount > activeDiscount) {
        activeDiscount = tier.discount;
      }
    });

    const priceWrappers = document.querySelectorAll('[data-price-wrapper]');

    priceWrappers.forEach((wrap) => {
      const comparePriceEl = wrap.querySelector('[data-compare-price]');
      const productPriceEl = wrap.querySelector('[data-product-price]');
      const priceOffEl = wrap.querySelector('[data-price-off]');
      const priceOffAmountEl = wrap.querySelector('[data-price-off-amount]');

      if (!productPriceEl) {
        return;
      }

      let price = variant.price;
      let comparePrice = variant.compare_at_price;

      if (activeDiscount > 0) {
        const discountMultiplier = (100 - activeDiscount) / 100;
        const discountedPrice = Math.round(price * discountMultiplier);

        if (!comparePrice || comparePrice <= price) {
          comparePrice = price;
        }

        price = discountedPrice;
      }

      if (!window.theme) {
        return;
      }

      const formatString = currencyCodeEnable ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;

      if (comparePriceEl) {
        if (comparePrice > price) {
          comparePriceEl.classList.remove('hidden');
          productPriceEl.classList.add('product__price--sale');
        } else {
          comparePriceEl.classList.add('hidden');
          productPriceEl.classList.remove('product__price--sale');
        }
        comparePriceEl.innerHTML = formatMoney(comparePrice, formatString);
      }

      if (price === 0) {
        productPriceEl.innerHTML = window.theme.strings.free || 'Free';
      } else {
        productPriceEl.innerHTML = formatMoney(price, formatString);
      }

      if (priceOffEl && priceOffAmountEl) {
        if (comparePrice > price) {
          priceOffEl.classList.remove('hidden');

          let savingsText = '';

          if (window.theme.settings?.savingBadgeType === 'amount') {
            savingsText = formatMoney(comparePrice - price, formatString);
          } else {
            savingsText = Math.round(((comparePrice - price) / comparePrice) * 100) + '%';
          }

          priceOffAmountEl.innerHTML = savingsText;
        } else {
          priceOffEl.classList.add('hidden');
        }
      }
    });
  };

  // Listener for variant changes
  document.addEventListener('theme:variant:change', (e) => {
    const variant = e.detail?.variant;

    if (variant) {
      window.theme.currentActiveVariant = variant;
    }

    updatePrices(window.theme.currentActiveVariant);
  });

  // Listener for cart updates
  document.addEventListener('theme:cart:added', () => {
    updatePrices(window.theme.currentActiveVariant);
  });
})();